exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.refund-dialog {\n  max-width: 1280px;\n}\n.refund-dialog .el-dialog__header {\n  padding: 14px 20px 10px;\n  border-bottom: 1px solid #ebeef5;\n}\n.refund-dialog .el-dialog__title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #303133;\n}\n.refund-dialog .el-dialog__body {\n  padding: 14px 20px 8px;\n}\n.refund-dialog .el-dialog__footer {\n  padding: 10px 20px 16px;\n  border-top: 1px solid #ebeef5;\n}\n", ""]);

// exports
